<div class="cover-all"  *ngIf="namePanelCoverVisible">
  <ng-template>
    <loader size="reverse"></loader>
  </ng-template>
</div>

  <div class="filter-selection-panel p-6 m-8 bg-white drop-shadow-md rounded-md">

      <ng-container *ngIf="!firstLevelFiltersSelected">
        <div class="division-info-message-block neptune-info-block">
          <img src="/assets/information-icon-black.svg" alt="information-icon" class="mr-4"/>
          <div class="info-message-text neptune-info-block-text">
            <span class="font-bold text-neptune-xl mb-1">{{selectedDivisionDataView?.division}} Division Selected</span>
            <span>
              <ng-container *ngIf="selectedDivisionDataView?.division != 'Distributor' else distributorMessage">
                Next: Choose a region and countries to view the filtered data on your dashboard
              </ng-container>
              <ng-template #distributorMessage>
                Next: Choose a partner group and distributor group to view the filtered data on your dashboard
              </ng-template>
            </span>
          </div>
        </div>
      </ng-container>

      <!-- Contract Filter selection header section -->
      <div class="contract-filter-selection-header neptune-filter-container pb-6">
        <div class="neptune-filter-title">Contract Filter Selection</div>
        <div class="save-clear-filters cursor-pointer">
          <a (click)="clickClearButton()" class="w-fit">
            Clear Filter
          </a>
          <save-filter-list-link (showFilterRecallPanel)="showFilterPanel()" (click)="namePanelCoverVisible=true;"></save-filter-list-link>
        </div>
      </div>

      <!-- Level 0 and 1 filters -->
      <div class="top-level-filter-dropdowns neptune-filter-container my-6 gap-6">
        <ng-container *ngIf="selectedDivisionDataView?.division != 'Distributor' else distributorFilters">
          <ng-container *ngFor="let filterOption of filterOptions; let index=index">
            <div id="filter-option-{{filterOption.id}}" class="flex flex-col w-1/2" *ngIf="filterOption.level <= 1">
                <app-filter-select
                            [id] = "getSanitizedFilterId(filterOption.title)"
                            [divDataView]="divDataView"
                            [title]="filterOption.title"
                            [isMultiple]="filterOption.isMultiple"
                            [required]="filterOption.required"
                            [disabled]="filterOption.disabled"
                            [hidden]="filterOption.hidden"
                            [optionList]="filterOption.optionList"
                            (sendSelect)="onFilterOptionSelect($event, filterOption)"
                            [currentlySelected]="filterOption.selected"
                            [isLoading]="filterOption.isLoading || false"
                          >
                </app-filter-select>
            </div>
          </ng-container>
        </ng-container>

        <!-- All Distributor Filters -->
        <ng-template #distributorFilters>
          <div class="flex flex-1 flex-col h-auto">
            <div class="flex">
              <div class="distributor-dropdown-filters w-2/3">
                <ng-container *ngTemplateOutlet="dropdownHeaderRow"></ng-container>
                <div class="flex flex-1 flex-wrap mr-8">
                  <ng-container *ngFor="let filterOption of filterOptions; let index=index">
                      <div id="filter-option-{{filterOption.id}}" class="flex flex-col w-1/2" *ngIf="filterOption.level <= 1 && filterOption.id != 'dateRange'">
                          <app-filter-select
                                      [id] = "getSanitizedFilterId(filterOption.title)"
                                      [divDataView]="divDataView"
                                      [title]="filterOption.title"
                                      [isMultiple]="filterOption.isMultiple"
                                      [required]="filterOption.required"
                                      [disabled]="filterOption.disabled"
                                      [hidden]="filterOption.hidden"
                                      [optionList]="filterOption.optionList"
                                      (sendSelect)="onFilterOptionSelect($event, filterOption)"
                                      [currentlySelected]="filterOption.selected"
                                      [isLoading]="filterOption.isLoading || false"
                                    >
                          </app-filter-select>

                    </div>
                  </ng-container>
                </div>

                <ng-container *ngTemplateOutlet="dateRangeFilter"></ng-container>

                <ng-container *ngIf="showCustomDatePickers">
                  <ng-container *ngTemplateOutlet="customDateRange"></ng-container>
                </ng-container>
              </div>
              <ng-container *ngTemplateOutlet="accountNumberInput"></ng-container>
            </div>
          </div>
        </ng-template>
      </div>

      <!-- Info message for contract selection -->
      <ng-container *ngIf="firstLevelFiltersSelected && selectedDivisionDataView?.division != 'Distributor'">
          <div class="hierarchy-info-block neptune-info-block">
            <img src="/assets/information-icon-black.svg" alt="information-icon" class="mr-4"/>
            <div class="neptune-info-block-text">
              <span>Here you can select contracts in two ways :</span>
              <ng-container [ngSwitch]="selectedDivisionDataView?.division">
                <ul class="list-disc ml-8">
                    <ng-container *ngSwitchCase="'Pest'">
                      <li>Use the Enterprise Name or Corporate Reference Name dropdowns</li>
                      <li>Enter service account IDs separated by commas for specific results Ex:value1, value2, value3...</li>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <li>Use the H5 or H7 dropdowns</li>
                      <li>Enter account numbers separated by commas for specific results Ex:value1, value2, value3...</li>
                    </ng-container>
                </ul>
              </ng-container>
            </div>
          </div>
      </ng-container>

      <!-- Other non-Distributor filters -->
      <ng-container *ngIf="firstLevelFiltersSelected && selectedDivisionDataView?.division != 'Distributor'">
        <div class="neptune-filter-row bottom-level-filter-dropdowns">
          <div class="flex flex-1 h-auto w-2/3 flex-wrap">
            <ng-container *ngTemplateOutlet="dropdownHeaderRow"></ng-container>
            <ng-container *ngFor="let filterOption of filterOptions; let index=index">
                <div id="filter-option-{{filterOption.id}}" class="dropdown-container flex flex-col w-1/2" *ngIf="filterOption.level >= 2 && filterOption.id != 'dateRange'">
                    <app-filter-select
                                [id] = "getSanitizedFilterId(filterOption.title)"
                                [divDataView]="divDataView"
                                [title]="filterOption.title"
                                [isMultiple]="filterOption.isMultiple"
                                [required]="filterOption.required"
                                [disabled]="filterOption.disabled"
                                [hidden]="filterOption.hidden"
                                [optionList]="filterOption.optionList"
                                (sendSelect)="onFilterOptionSelect($event, filterOption)"
                                [currentlySelected]="filterOption.selected"
                                [isLoading]="filterOption.isLoading || false"
                              >
                    </app-filter-select>
                </div>
            </ng-container>

            <!-- Date range row -->
            <div class="date-range-filter-row">
              <ng-container *ngTemplateOutlet="dateRangeFilter"></ng-container>
            </div>

            <!-- Custom Date picker -->
            <ng-container *ngIf="showCustomDatePickers">
              <ng-container *ngTemplateOutlet="customDateRange"></ng-container>
            </ng-container>
          </div>

          <!-- Account number input -->
          <ng-container *ngIf="selectedDivisionDataView?.division != 'Distributor'">
            <ng-container *ngTemplateOutlet="accountNumberInput"></ng-container>
          </ng-container>
        </div>
      </ng-container>

      <!-- Save this selection box (no border bottom)-->
      <ng-container *ngIf="selectedDivisionDataView?.division == 'Distributor' ? isSaveSelectionLinkVisible : firstLevelFiltersSelected && isSaveSelectionLinkVisible">
       <div class="save-selection-box flex justify-end mb-6 items-star" [ngClass] ="selectedDivisionDataView?.division != 'Distributor' ? 'border-1 border-solid border-white border-t-sky-blue' : ''">
          <div class="neptune-button-white mt-3 p-3 cursor-pointer">
            <a
            (click)="showFilterNamePanel()"
            id = "save-filter-now-link"
            >
              Save This Selection
            </a>
          </div>

      </div>
      </ng-container>
  </div>

  <ng-container *ngTemplateOutlet="filterRecallPanel" class="p-0 m-0"></ng-container>

<!-- Filter recall panel template -->
<ng-template #filterRecallPanel>
  <filter-recall-panel
          divDataView = {{divDataView}}
          (hideFilterRecallPanel)="hideFilterPanel(); hideCover();"
          (recallSavedFilters)="recallSavedFilters()"
          *ngIf="filterRecallVisible">
    </filter-recall-panel>
    <filter-name-panel
      divDataView = {{divDataView}}
      (hideFilterNamePanel)="hideFilterNamePanel(); hideCover();"
      *ngIf="filterSaveNameVisible">
    </filter-name-panel>
</ng-template>

<!-- Account number input template -->
<ng-template #accountNumberInput>
  <div id="filter-option-account-input" class="flex flex-col w-1/3">
    <div class="neptune-filter-title pb-6">
      Through Search
    </div>
    <ng-container *ngIf="isAcctNumberVisible || acctNumLevel == 0">
            <app-account-specific-filter
              id="account-filter"
              [divDataView]="divDataView"
              accountFieldTitle="Account Numbers"
              (sendSelect)="onAccountNumberTyping($event)"
              #accountTextArea
            >
            </app-account-specific-filter>
    </ng-container>
  </div>
</ng-template>

<!-- Date range template -->
<ng-template #dateRangeFilter>
  <ng-container *ngFor="let filterOption of filterOptions; let index=index">
      <div class="flex flex-col" *ngIf="filterOption.id == 'dateRange'">
          <app-filter-select
                      [id] = "'select-'+ filterOption.title.toLowerCase().replace(' ', '-')"
                      [divDataView]="divDataView"
                      [title]="filterOption.title"
                      [isMultiple]="filterOption.isMultiple"
                      [required]="filterOption.required"
                      [disabled]="filterOption.disabled"
                      [hidden]="filterOption.hidden"
                      [optionList]="filterOption.optionList"
                      (sendSelect)="onFilterOptionSelect($event, filterOption)"
                      [currentlySelected]="filterOption.selected"
                      [isLoading]="filterOption.isLoading || false"
                    >
          </app-filter-select>
      </div>
  </ng-container>
</ng-template>

<!-- Custom date range template -->
<ng-template #customDateRange>
  <div class="neptune-custom-date-picker-container custom-date-picker-container flex flex-1 pt-6">
    <div class="custom-date-start-container flex flex-col w-1/2 mr-6">
      <span>Start Date</span>
      <mat-form-field appearance="outline" floatLabel="auto" class="calendar-form" id="start-date-form" class="w-full">
          <input matInput [min]="minimumDate"
                          [max]="maximumDate"
                          [matDatepicker]="startDP" placeholder="MMM-YYYY" [formControl]="startDate">
          <mat-datepicker-toggle [for]="startDP"></mat-datepicker-toggle>
          <mat-datepicker #startDP
                    startView="multi-year"
                    (monthSelected)="setMonthAndYear($event, startDP, 'startDP')"
                    >
          </mat-datepicker>
      </mat-form-field>
    </div>
    <div class="custom-date-end-container flex flex-col w-1/2 mr-6">
      <span>End Date</span>
      <mat-form-field appearance="outline" floatLabel="auto" class="calendar-form" id="end-date-form" class="full">
          <input matInput [min]="minimumDate"
                          [max]="maximumDate"
                          [matDatepicker]="endDP" placeholder="MMM-YYYY" [formControl]="endDate">
          <mat-datepicker-toggle [for]="endDP"></mat-datepicker-toggle>
          <mat-datepicker #endDP
                    startView="multi-year"
                    (monthSelected)="setMonthAndYear($event, endDP, 'endDP')"
                    >
          </mat-datepicker>
      </mat-form-field>
      <div *ngIf="!isApplyButtonEnabled" id="custom-dateRange-error-message">End month cannot be prior to start month.</div>
    </div>
  </div>
</ng-template>

<!-- Low level filters dropdown header row -->
<ng-template #dropdownHeaderRow>
  <div class="dropdown-header-row pb-6 w-full flex justify-between">
    <span class="neptune-filter-title ">Through Dropdowns</span>
    <!-- Show Exclude deleted accounts checkbox only for Institutional/QSR/FRS. Other divisions pending -->
    <div class="exclude-deleted-accounts-input" *ngIf="!hideExcludeDeletedAccountsCheckbox">
      <input type="checkbox" id="select-all-checkbox" class="neptune-checkbox mr-2 exclude-deleted-accounts-checkbox" [(ngModel)]="excludeDeletedAccounts" (change)="onSelectExcludeDeletedAccounts()" />
      <label>
        Exclude Deleted Accounts
      </label>
    </div>
    <span class="font-bold" [ngClass]="selectedDivisionDataView?.division == 'Distributor' ? 'pr-6' : ''">Or</span>
  </div>
</ng-template>
